import { useApiQuery } from '../use-api.js';
import { AuditLogPanel, type AuditEntry } from '../components/AuditLogPanel.js';

export function ConfigAudit() {
  const audit = useApiQuery<AuditEntry[]>(
    ['audit-global-full'],
    '/api/audit?global=true&limit=200',
  );
  return (
    <AuditLogPanel
      events={audit.data ?? []}
      isLoading={audit.isLoading}
      error={audit.error}
      title="Audit log"
    />
  );
}
